import type { SupportedRenderCard } from '../../../insightRenderShapes'
import { PopulationStep } from '../PopulationStep'
import { Answer } from '../InsightsBlocks'
import { formatInsightDatum } from './formatInsightDatum'

export function PopulationStepsCard({ card }: { card: Extract<SupportedRenderCard, { kind: 'population-steps' }> }) {
  const base = card.base.result
  const steps = card.steps.map(({ datum, emphasis }, index) => {
    const figure = formatInsightDatum(datum)
    if (base.state !== 'available' || base.value === 0 || datum.result.state !== 'available')
      return (
        <Answer key={index} figure={figure} label={datum.label} size="large-200" strongLabel={emphasis === 'primary'} />
      )
    return (
      <PopulationStep
        key={index}
        arrow={index > 0}
        primary={emphasis === 'primary'}
        label={datum.label}
        value={datum.result.value}
        max={base.value}
        formatCount={() => figure}
        accessibilityLabel={`${datum.label}: ${figure}`}
      />
    )
  })
  return (
    <s-query-container>
      <s-grid gridTemplateColumns="@container (inline-size <= 600px) 1fr, 1fr 1fr 1fr" gap="base" alignItems="stretch">
        {steps}
      </s-grid>
    </s-query-container>
  )
}
